/**
 *    Copyright 2018 the original author or authors
 *
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 *
 *        http://www.apache.org/licenses/LICENSE-2.0
 *
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 */
import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { tap } from 'rxjs/operators/tap';
import { of } from 'rxjs/observable/of';
import { RestService } from '../rest';
import { ExtModelMetaConfig } from './models';
var ModelMetaService = /** @class */ (function () {
    function ModelMetaService(config, rest) {
        this.config = config;
        this.rest = rest;
    }
    /**
     * Get a single module
     *
     * @param model
     * @param projecion
     */
    ModelMetaService.prototype.getModel = function (model, projecion) {
        var _this = this;
        if (this.modelMap && this.modelMap.has(model)) {
            return of(this.modelMap.get(model));
        }
        else {
            var params = new HttpParams();
            if (projecion) {
                params = params.append('projection', projecion);
            }
            var url = this.config.modelsUrl + '/' + model.toLowerCase();
            return this.rest
                .get(url, { params: params })
                .pipe(tap(function (modelMeta) { return _this.addToMap(modelMeta); }));
        }
    }; // getModel()
    ModelMetaService.prototype.addToMap = function (modelMeta, projection) {
        if (!this.modelMap)
            this.modelMap = new Map();
        this.modelMap.set(modelMeta.name + '_' + projection, modelMeta);
    };
    /** Get all the models exposed by the backend.*/
    ModelMetaService.prototype.getModels = function () {
        var _this = this;
        if (this.initiated) {
            return of(Array.from(this.modelMap.values()));
        }
        else
            return this.rest.get(this.config.modelsUrl).pipe(tap(function (modelMetas) {
                _this.initiated = true;
                modelMetas.forEach(function (modelMeta) { return _this.addToMap(modelMeta); });
            }));
    }; // getModels()
    ModelMetaService = tslib_1.__decorate([
        Injectable(),
        tslib_1.__metadata("design:paramtypes", [ExtModelMetaConfig, RestService])
    ], ModelMetaService);
    return ModelMetaService;
}()); // class
export { ModelMetaService };
//# sourceMappingURL=modelMeta.service.js.map